// PRIMEIRO de tudo: limpa o storage (se a versão mudou) antes de qualquer store ler.
import "./utils/bootReset";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { watchForNewBuild } from "./utils/appRefresh";

import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/bff\.granatech\.com\.br/,
        /^https:\/\/bff-dev\.granatech\.com\.br/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);

// Recarrega a aba quando um build novo for publicado (inclusive abas já abertas).
void watchForNewBuild();
